<div class="pyramid-display">
  <div class="pyr-stage" *ngIf="bands.length">
    <svg class="pyr-svg" viewBox="0 0 300 320" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="pyramidBandFill" gradientUnits="userSpaceOnUse" x1="150" y1="18" x2="150" y2="300">
          <stop offset="0" stop-color="#BCC8ED"></stop>
          <stop offset="1" stop-color="#DCE3F5"></stop>
        </linearGradient>
      </defs>
      <polygon *ngFor="let band of bands; trackBy: trackByUuid"
               [attr.points]="band.points"
               fill="url(#pyramidBandFill)"></polygon>
    </svg>

    <div class="pyr-value" *ngFor="let band of bands; trackBy: trackByUuid"
         [ngStyle]="{'top.px': band.valueTop}">
      <img class="pyr-value-arrow" *ngIf="band.category.trend"
           [src]="band.category.trend === 'up' ?
             '../../../assets/svg/indicator-arrow-up.svg' :
             '../../../assets/svg/indicator-arrow-down.svg'"
           alt="">
      <span class="pyr-value-score">{{ band.category.score }}</span>
      <small class="pyr-value-percentage">%</small>
    </div>

    <button class="pchip" type="button"
            *ngFor="let band of bands; trackBy: trackByUuid"
            [ngStyle]="{'top.px': band.chipTop, 'left.px': band.chipLeft}"
            (click)="selectCategory(band.category)">
      <span class="chip" [ngStyle]="{
              'background-image': band.category.gradientColor,
              'width.px': band.chipSize,
              'height.px': band.chipSize
            }">
        <img [src]="band.category.icon" [alt]="band.category.title"
             [ngStyle]="{'width.px': band.iconSize, 'height.px': band.iconSize}">
      </span>
      <span class="pchip-label">{{ band.category.title }}</span>
    </button>
  </div>

  <div class="pyr-legend" *ngIf="showLegend && legend.length && bands.length">
    <span class="pyr-legend-item" *ngFor="let item of legend">
      <i [ngStyle]="{'background-color': item.color}"></i>
      <span>{{ item.label }}</span>
    </span>
  </div>
</div>
